import React, { useState } from "react";

interface AssessmentFormProps {
  initialData?: any;
  onSave: (data: any) => void;
  onCancel: () => void;
}

const AssessmentForm: React.FC<AssessmentFormProps> = ({
  initialData,
  onSave,
  onCancel,
}) => {
  const [formData, setFormData] = useState({
    vitals: {
      pulse: initialData?.vitals?.pulse || "",
      bp: initialData?.vitals?.bp || "",
      temp: initialData?.vitals?.temp || "",
      spo2: initialData?.vitals?.spo2 || "",
      rr: initialData?.vitals?.rr || "",
      cvs: initialData?.vitals?.cvs || "",
    },
    notes: initialData?.notes || "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  const updateVital = (key: string, value: string) => {
    setFormData({
      ...formData,
      vitals: {
        ...formData.vitals,
        [key]: value,
      },
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Pulse (bpm)
          </label>
          <input
            type="text"
            value={formData.vitals.pulse}
            onChange={(e) => updateVital("pulse", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="e.g., 72"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            BP (mmHg)
          </label>
          <input
            type="text"
            value={formData.vitals.bp}
            onChange={(e) => updateVital("bp", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="e.g., 120/80"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Temperature (°F)
          </label>
          <input
            type="text"
            value={formData.vitals.temp}
            onChange={(e) => updateVital("temp", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="e.g., 98.6"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            SpO2 (%)
          </label>
          <input
            type="text"
            value={formData.vitals.spo2}
            onChange={(e) => updateVital("spo2", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="e.g., 98"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Respiratory Rate (RR)
          </label>
          <input
            type="text"
            value={formData.vitals.rr}
            onChange={(e) => updateVital("rr", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="e.g., 16"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            CVS (Cardiovascular System)
          </label>
          <input
            type="text"
            value={formData.vitals.cvs}
            onChange={(e) => updateVital("cvs", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="e.g., Normal"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Notes</label>
        <textarea
          value={formData.notes}
          onChange={(e) =>
            setFormData({ ...formData, notes: e.target.value })
          }
          rows={4}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
          placeholder="Additional assessment notes..."
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
        >
          Save Assessment
        </button>
      </div>
    </form>
  );
};

export default AssessmentForm;


